export default __webpack_public_path__ + "static/media/50 inex_01.bfcd670e.png";